import React, {FC} from "react";
import {
    Box,
    IconButton,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {FallbackImage} from "../FallbackImage";

interface ThumbnailListProps {
    images: string[];
    motorcycleName: string;
    mainIndex: number;
    setMainIndex: (index: number) => void;
    errorIndices: number[];
    handleError: (index: number) => void;
    containerRef?: React.RefObject<HTMLDivElement>;
    scrollLeft?: () => void;
    scrollRight?: () => void;
    sx?: object;
    showControls?: boolean;
}

export const ThumbnailList: FC<ThumbnailListProps> = ({
    images,
    motorcycleName,
    mainIndex,
    setMainIndex,
    errorIndices,
    handleError,
    containerRef,
    scrollLeft,
    scrollRight,
    sx,
}) => {
    return (
        <Box sx={{display: "flex", alignItems: "center", ...sx}}>
            {scrollLeft && (
                <IconButton onClick={(e) => {
                    e.stopPropagation();
                    scrollLeft();
                }}>
                    <ArrowBackIosIcon/>
                </IconButton>
            )}
            <Box
                ref={containerRef}
                sx={{
                    display: "flex",
                    gap: 1,
                    flexGrow: 1,
                    overflowX: "auto",
                    overflowY: "hidden",
                    height: 60,
                }}
            >
                {images.map((imageName, index) => {
                    const thumbSrc = `https://fyd.ge/fyd-images/${motorcycleName}/${imageName}`;
                    const isSelected = index === mainIndex;
                    return (
                        <Box
                            key={index}
                            onClick={(e) => {
                                e.stopPropagation();
                                setMainIndex(index);
                            }}
                            sx={{
                                border: isSelected ? "2px solid" : "2px solid transparent",
                                borderColor: isSelected ? "primary.main" : "transparent",
                                borderRadius: 1,
                                cursor: "pointer",
                                width: 80,
                                height: 60,
                                flexShrink: 0,
                            }}
                        >
                            {errorIndices.includes(index) ? (
                                <FallbackImage/>
                            ) : (
                                <Box
                                    component="img"
                                    src={thumbSrc}
                                    alt={`${motorcycleName} thumb ${index}`}
                                    onError={() => handleError(index)}
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: 1,
                                    }}
                                />
                            )}
                        </Box>
                    );
                })}
            </Box>
            {scrollRight && (
                <IconButton onClick={(e) => {
                    e.stopPropagation();
                    scrollRight();
                }}>
                    <ArrowForwardIosIcon/>
                </IconButton>
            )}
        </Box>
    );
};

